import React, { useState, useEffect } from 'react';
import cc from 'classcat';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = "@keyframes react-icon_1-28-0_wave {\n  0% {\n    background-position: 0 0;\n  }\n  100% {\n    background-position: 600px 0;\n  }\n}\n@font-face {\n  font-family: \"Material-Icons-TD-1-28-0\";\n  src: url(\"https://prd-cdn-talkdesk.talkdesk.com/cobalt-utils/assets/1.28.0/fonts/Material-Icons-TD.woff2\") format(\"woff2\"), url(\"https://prd-cdn-talkdesk.talkdesk.com/cobalt-utils/assets/1.28.0/fonts/Material-Icons-TD.ttf\") format(\"truetype\"), url(\"https://prd-cdn-talkdesk.talkdesk.com/cobalt-utils/assets/1.28.0/fonts/Material-Icons-TD.woff\") format(\"woff\"), url(\"https://prd-cdn-talkdesk.talkdesk.com/cobalt-utils/assets/1.28.0/fonts/Material-Icons-TD.svg\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n.react-icon_1-28-0_co-icon {\n  box-sizing: border-box;\n  font-family: \"Material-Icons-TD-1-28-0\" !important;\n  speak: none;\n  user-select: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  letter-spacing: 0;\n  -webkit-font-feature-settings: \"liga\";\n  -moz-font-feature-settings: \"liga=1\";\n  -moz-font-feature-settings: \"liga\";\n  -ms-font-feature-settings: \"liga\" 1;\n  font-feature-settings: \"liga\";\n  -webkit-font-variant-ligatures: discretionary-ligatures;\n  font-variant-ligatures: discretionary-ligatures;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n@keyframes react-icon_1-28-0_wave {\n  0% {\n    background-position: 0 0;\n  }\n  100% {\n    background-position: 600px 0;\n  }\n}\n.react-icon_1-28-0_co-icon.react-icon_1-28-0_co-icon--micro {\n  font-size: 16px;\n  height: 16px;\n  width: 16px;\n}\n.react-icon_1-28-0_co-icon.react-icon_1-28-0_co-icon--tiny {\n  font-size: 20px;\n  height: 20px;\n  width: 20px;\n}\n.react-icon_1-28-0_co-icon.react-icon_1-28-0_co-icon--small {\n  font-size: 24px;\n  height: 24px;\n  width: 24px;\n}\n.react-icon_1-28-0_co-icon.react-icon_1-28-0_co-icon--medium {\n  font-size: 32px;\n  height: 32px;\n  width: 32px;\n}\n.react-icon_1-28-0_co-icon.react-icon_1-28-0_co-icon--large {\n  font-size: 48px;\n  height: 48px;\n  width: 48px;\n}\n.react-icon_1-28-0_co-icon.react-icon_1-28-0_co-icon--xlarge {\n  font-size: 64px;\n  height: 64px;\n  width: 64px;\n}\n.react-icon_1-28-0_co-icon.react-icon_1-28-0_co-icon--loading {\n  animation: react-icon_1-28-0_wave 1s infinite linear;\n  background: linear-gradient(to right, var(--basic-200, #f2f4f5) 0%, var(--basic-300, #e8eaeb) 40%, var(--basic-200, #f2f4f5) 60%);\n  background-size: 600px;\n  border-radius: var(--border-radius-xsmall, 4px);\n  font-size: 0;\n  min-width: 18px;\n}\n\n.react-icon_1-28-0_co-icon--clickable {\n  padding: 0;\n  margin: 0;\n  color: inherit;\n  background-color: inherit;\n  border: none;\n  outline: 0;\n  cursor: pointer;\n}\n.react-icon_1-28-0_co-icon--clickable:not([data-co-disabled])[data-co-focus], .react-icon_1-28-0_co-icon--clickable:not([data-co-disabled]):focus {\n  box-shadow: 0 0 0 2px var(--primary-400, #d7dbde);\n}\n.react-icon_1-28-0_co-icon--clickable[data-co-disabled] {\n  pointer-events: none;\n}\n\n.react-icon_1-28-0_sr-only {\n  position: absolute !important;\n  top: 0;\n  left: 0;\n  height: 1px;\n  width: 1px;\n  overflow: hidden;\n  padding: 0 !important;\n  border: 0 !important;\n  white-space: nowrap !important;\n  clip: rect(1px 1px 1px 1px) !important;\n  /* IE6, IE7 */\n  clip: rect(1px, 1px, 1px, 1px) !important;\n  clip-path: inset(50%) !important;\n}";
var styles = {
  "co-icon": "react-icon_1-28-0_co-icon",
  "co-icon--micro": "react-icon_1-28-0_co-icon--micro",
  "co-icon--tiny": "react-icon_1-28-0_co-icon--tiny",
  "co-icon--small": "react-icon_1-28-0_co-icon--small",
  "co-icon--medium": "react-icon_1-28-0_co-icon--medium",
  "co-icon--large": "react-icon_1-28-0_co-icon--large",
  "co-icon--xlarge": "react-icon_1-28-0_co-icon--xlarge",
  "co-icon--loading": "react-icon_1-28-0_co-icon--loading",
  "wave": "react-icon_1-28-0_wave",
  "co-icon--clickable": "react-icon_1-28-0_co-icon--clickable",
  "sr-only": "react-icon_1-28-0_sr-only"
};
styleInject(css);

// This file is generated automatically by processIcons.ts
const FONT_FAMILY_VERSION = "1-28-0";

const getClassName = modifier => modifier ? `co-icon--${modifier}` : "";

const Icon = ({
  className = "",
  forwardedRef,
  name,
  accessibilityLabel,
  color,
  disabled,
  onClick,
  size,
  style,
  ...props
}) => {
  const [loaded, setFontLoaded] = useState(false);
  useEffect(() => {
    if (loaded) return;

    if ("fonts" in document) {
      document.fonts.load(`0px Material-Icons-TD-${FONT_FAMILY_VERSION}`).finally(() => setFontLoaded(true));
    } else {
      setFontLoaded(true);
    }
  }, [loaded]);
  const classStyles = {
    [styles["co-icon"]]: true,
    [styles[getClassName(size)]]: !!size,
    [styles["co-icon--loading"]]: !loaded,
    [className]: !!className
  };
  return onClick ? /*#__PURE__*/React.createElement("button", _extends({
    className: styles["co-icon--clickable"],
    "data-co-disabled": disabled || undefined,
    "aria-disabled": disabled || undefined,
    onClick: !disabled ? onClick : undefined
  }, props, {
    "data-co-name": "Icon",
    "data-co-version": "1.28.0",
    "data-co-project": "cobalt"
  }), /*#__PURE__*/React.createElement("i", {
    className: cc(classStyles),
    ref: forwardedRef,
    style: {
      color,
      ...style
    },
    "aria-hidden": true
  }, name), /*#__PURE__*/React.createElement("span", {
    className: styles["sr-only"]
  }, accessibilityLabel)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("i", _extends({
    className: cc(classStyles),
    ref: forwardedRef,
    style: {
      color,
      ...style
    },
    "aria-hidden": true
  }, props, {
    "data-co-name": "Icon",
    "data-co-version": "1.28.0",
    "data-co-project": "cobalt"
  }), name), /*#__PURE__*/React.createElement("span", {
    className: styles["sr-only"],
    "data-co-name": "Icon",
    "data-co-version": "1.28.0",
    "data-co-project": "cobalt"
  }, accessibilityLabel));
};

// This file is generated automatically by processIcons.ts
const iconsCatalog = {
  applause: ["applause"],
  applause_border: ["applause_border"],
  calendar_medical: ["calendar_medical"],
  account_balance_wallet: ["account_balance_wallet"],
  account_box: ["account_box"],
  account_circle: ["account_circle"],
  add_shopping_cart: ["add_shopping_cart"],
  alarm: ["alarm"],
  alarm_add: ["alarm_add"],
  alarm_off: ["alarm_off"],
  alarm_on: ["alarm_on"],
  all_inbox: ["all_inbox", "accounts"],
  aspect_ratio: ["aspect_ratio"],
  bookmark: ["bookmark"],
  bookmark_border: ["bookmark_border"],
  cached: ["cached"],
  calendar_today: ["calendar_today"],
  check_circle: ["check_circle", "confirm_circle"],
  check_circle_outline: ["check_circle_outline"],
  code: ["code", "code_brackets"],
  code_braces: ["code_braces", "curly_braces"],
  compare_arrows: ["compare_arrows"],
  copy: ["copy"],
  credit_card: ["credit_card"],
  dashboard: ["dashboard"],
  date_range: ["date_range", "calendar"],
  delete_outline: ["delete_outline", "trash"],
  description: ["description"],
  done: ["done", "confirm"],
  drag_indicator: ["drag_indicator"],
  euro_symbol: ["euro", "euro_symbol"],
  event: ["event"],
  exit_to_app: ["exit_to_app"],
  face: ["face"],
  face_unlock: ["face_outline", "face_unlock"],
  favorite: ["favorite", "heart"],
  favorite_border: ["favorite_outline", "heart_outline", "favorite_border"],
  feedback: ["feedback", "announcement"],
  hashtag: ["hashtag"],
  help_outline: ["help_outline", "help_circle_outline"],
  highlight_off: ["close_outline", "highlight_off"],
  history: ["history"],
  home: ["home"],
  hourglass_full: ["hourglass_full"],
  info: ["info", "info_circle"],
  info_outline: ["info_outline", "info_circle_outline"],
  input: ["input"],
  label: ["label"],
  label_important: ["label_important"],
  label_important_outline: ["label_important_outline"],
  label_off: ["label_off"],
  label_outline: ["label_outline"],
  language: ["language", "globe"],
  lightbulb_outline: ["lightbulb_outline"],
  list: ["list"],
  lock: ["lock"],
  lock_open: ["lock_open"],
  lock_outline: ["lock_outline"],
  logout: ["logout"],
  open_in_browser: ["open_in_browser"],
  open_in_new: ["open_in_new", "open_in"],
  open_with: ["open_with", "move"],
  pageview: ["pageview"],
  payment: ["payment"],
  picture_in_picture: ["picture_in_picture", "pip"],
  picture_in_picture_alt: ["picture_in_picture_alt", "pip_alt"],
  power_settings_new: ["power_on", "power_settings_new"],
  print: ["print"],
  receipt: ["receipt"],
  record_voice_over: ["voice_over", "record_voice_over"],
  remove_shopping_cart: ["remove_shopping_cart"],
  reorder: ["reorder"],
  restore: ["restore"],
  search: ["search"],
  settings: ["settings"],
  settings_backup_restore: ["backup_restore", "settings_backup_restore"],
  settings_ethernet: ["settings_ethernet"],
  settings_overscan: ["settings_overscan"],
  shopping_cart: ["shopping_cart"],
  subject: ["subject"],
  supervised_user_circle: ["supervised_user_circle"],
  swap_horizontal_circle: ["swap_horizontal_circle"],
  swap_vert: ["swap_vertical", "swap_vert"],
  swap_vertical_circle: ["swap_vertical_circle"],
  system_vertical_alt: ["system_vertical_alt"],
  thumb_down: ["thumb_down"],
  thumb_up: ["thumb_up"],
  thumbs_up_down: ["thumbs_up_down"],
  timeline: ["timeline"],
  toc: ["toc"],
  today: ["today"],
  touch_app: ["touch", "touch_app"],
  translate: ["translate"],
  trending_down: ["trending_down"],
  trending_up: ["trending_up"],
  update: ["update"],
  verified_user: ["verified_user"],
  vertical_split: ["vertical_split"],
  view_agenda: ["view_agenda"],
  view_array: ["view_array"],
  view_carousel: ["view_carousel"],
  view_column: ["view_column"],
  view_day: ["view_day"],
  view_headline: ["view_headline"],
  view_list: ["view_list"],
  view_module: ["view_module"],
  view_quilt: ["view_quilt"],
  view_stream: ["view_stream"],
  view_week: ["view_week"],
  visibility: ["visibility"],
  visibility_off: ["visibility_off"],
  voice_over_off: ["voice_over_off"],
  work: ["work", "briefcase"],
  work_off: ["work_off", "briefcase_off"],
  work_outline: ["work_outline", "briefcase_outline"],
  youtube_searched_for: ["searched_for", "youtube_searched_for"],
  zoom_in: ["zoom_in"],
  zoom_out: ["zoom_out"],
  donut_large: ["donut_large"],
  hourglass_empty: ["hourglass_empty"],
  perm_contact_calendar: ["contact_calendar", "perm_contact_calendar"],
  stars: ["star_circle", "stars"],
  star_rate: ["star_rate"],
  assignment: ["assignment"],
  assignment_ind: ["assignment_ind"],
  assignment_late: ["assignment_late"],
  assignment_return: ["assignment_return"],
  assignment_returned: ["assignment_returned"],
  assignment_turned_in: ["assignment_turned_in"],
  build: ["build"],
  flip_to_front: ["flip_to_front"],
  flip_to_back: ["flip_to_back"],
  note_add: ["note_add"],
  extension: ["extension"],
  speaker_notes_off: ["speaker_notes_off"],
  question_answer: ["question_answer"],
  speaker_notes: ["speaker_notes"],
  shopping_basket: ["shopping_basket"],
  offline_bolt: ["bolt_circle", "offline_bolt"],
  accessibility: ["accessibility"],
  donut_small: ["donut_small"],
  group_work: ["group_work"],
  perm_media: ["media", "perm_media"],
  feedback_outline: ["feedback_outline"],
  done_all: ["done_all"],
  settings_transfer: ["settings_transfer"],
  bring_back: ["bring_back"],
  cup: ["cup"],
  unbookmark_border: ["unbookmark_border"],
  unbookmark: ["unbookmark"],
  wysiwyg: ["wysiwyg"],
  lock_shield: ["lock_shield"],
  verified: ["verified"],
  push_pin_outline: ["push_pin_outline"],
  push_pin: ["push_pin"],
  credit_score: ["credit_score"],
  extension_off: ["extension_off"],
  play_extension: ["play_extension"],
  store: ["store"],
  thumb_down_outline: ["thumb_down_outline"],
  thumb_up_outline: ["thumb_up_outline"],
  supervised_user_circle_outline: ["supervised_user_circle_outline"],
  spoofing_detection: ["spoofing_detection"],
  pin_invoke: ["pin_invoke"],
  add: ["notification_add"],
  error: ["error", "error_circle", "exclamation_circle"],
  error_outline: ["error_outline", "error_circle_outline"],
  notification_important: ["notification_important"],
  warning: ["warning", "alert"],
  warning_amber: ["warning_outline", "warning_amber"],
  web_asset: ["web_asset"],
  add_to_queue: ["add_to_queue"],
  airplay: ["airplay"],
  fiber_manual_record: ["record", "fiber_manual_record"],
  mic: ["mic"],
  mic_off: ["mic_off", "mic_stop"],
  play_circle_outline: ["play_circle_outline"],
  playlist_add: ["playlist_add"],
  playlist_add_check: ["playlist_add_check"],
  playlist_play: ["playlist_play"],
  shuffle: ["shuffle"],
  sort_by_alpha: ["sort_by_alpha"],
  videocam_off: ["videocam_off", "video_stop"],
  volume_off: ["volume_off", "sound_stop"],
  volume_up: ["volume_up", "sound"],
  videocam: ["videocam", "video"],
  equalizer: ["equalizer"],
  library_add: ["library_add", "clone"],
  library_books: ["library_books"],
  pause: ["pause"],
  pause_circle_filled: ["pause_circle", "pause_circle_filled"],
  pause_circle_outline: ["pause_circle_outline"],
  play_arrow: ["play_arrow", "play"],
  play_circle_filled: ["play_circle", "play_circle_filled"],
  recent_actors: ["recent_actors"],
  repeat: ["repeat"],
  replay: ["replay"],
  stop: ["stop"],
  volume_mute: ["volume_mute"],
  volume_down: ["volume_down"],
  stop_circle_filled: ["stop_circle_filled"],
  stop_circle_outline: ["stop_circle_outline"],
  slow_motion_video: ["slow_motion_video"],
  web: ["web"],
  fast_forward: ["fast_forward"],
  fast_rewind: ["fast_rewind"],
  skip_next: ["skip_next"],
  skip_previous: ["skip_previous"],
  video_call: ["add_video_call", "video_call"],
  recording_stop: ["recording_stop"],
  subtitles: ["subtitles"],
  hearing: ["hearing"],
  filmstrip: ["filmstrip"],
  zendesk: ["zendesk"],
  salesforce: ["salesforce"],
  facebook: ["facebook", "fb"],
  "facebook-messenger": ["messenger", "fb_messenger"],
  slack: ["slack"],
  snapchat: ["snapchat"],
  twitter: ["twitter"],
  wechat: ["wechat"],
  whatsapp: ["whatsapp"],
  telegram: ["telegram"],
  msdynamics: ["msdynamics"],
  msteams: ["msteams"],
  discord: ["discord"],
  servicenow: ["servicenow"],
  talkdesk: ["talkdesk", "td"],
  freshdesk: ["freshdesk"],
  zoho: ["zoho"],
  kustomer: ["kustomer"],
  viber: ["viber"],
  livechat: ["livechat"],
  helpscout: ["helpscout"],
  bigcommerce: ["bigcommerce"],
  hubspot: ["hubspot"],
  keap: ["keap"],
  zoom: ["zoom"],
  onepagecrm: ["onepagecrm"],
  pipedrive: ["pipedrive"],
  intercom: ["intercom"],
  olark: ["olark"],
  shopify: ["shopify"],
  nimble: ["nimble"],
  contactually: ["contactually"],
  freshservice: ["freshservice"],
  c2perform: ["c2perform"],
  confluence: ["confluence"],
  add_call: ["add_call", "phone_new_call"],
  arrow_right_alt: ["transfer_blind", "arrow_right_alt"],
  call: ["call", "phone"],
  call_end: ["call_end", "hangup", "phone_end"],
  call_list: ["call_list", "calls_list"],
  call_made: ["call_made", "outbound"],
  call_merge: ["call_merge"],
  call_missed: ["call_missed"],
  call_missed_outgoing: ["call_missed_outgoing"],
  call_received: ["call_received", "inbound"],
  call_split: ["call_split"],
  dialer_sip: ["phone_sip", "dialer_sip"],
  dialpad: ["dialpad", "keypad"],
  perm_phone_msg_24px: ["phone_msg", "perm_phone_msg"],
  phone_bluetooth_speaker: ["phone_bluetooth", "phone_bluetooth_speaker"],
  phone_callback: ["phone_incoming", "phone_callback", "call_inbound"],
  phone_dropped: ["phone_dropped", "call_dropped"],
  phone_forwarded: ["call_transfer", "phone_forwarded"],
  phone_in_talk: ["phone_in_talk"],
  phone_locked: ["phone_locked"],
  phone_missed: ["phone_missed"],
  phone_outbound: ["phone_outbound", "call_outbound"],
  phone_paused: ["phone_paused"],
  phone_short_abandoned: ["phone_short_abandoned", "call_short_abandoned"],
  recordings: ["recordings"],
  ring_volume: ["ring_volume"],
  settings_phone: ["phone_settings", "settings_phone", "call_noticeable_delay"],
  swap_horiz: ["transfer", "swap_horiz"],
  transfer_warm: ["transfer_warm"],
  voicemail: ["voicemail"],
  voicemail_drop: ["voicemail_drop"],
  queue: ["call_queue"],
  "transfer-warm-in": ["transfer_warm_in"],
  a2a_in: ["agent_in"],
  a2a_out: ["agent_out"],
  consultation_out: ["consultation_out"],
  consultation_in: ["consultation_in"],
  agent: ["agent"],
  phone_disabled: ["phone_disabled"],
  phone_valid: ["phone_valid"],
  connect_to_agent: ["connect_to_agent"],
  dial_agent: ["dial_agent"],
  forward_to_uc: ["forward_to_uc"],
  forward_to_phone: ["forward_to_phone"],
  stay_current_portrait: ["stay_current_portrait"],
  alternate_email: ["alternate_email"],
  clear_all: ["clear_all"],
  contact_mail: ["contact_mail"],
  contact_phone: ["contact_phone"],
  contacts: ["contacts"],
  forum: ["forum"],
  import_export: ["import_export"],
  list_alt: ["list_alt", "events"],
  location_off: ["location_off"],
  mail_outline: ["email_outline", "mail_outline"],
  vpn_key: ["vpn_key", "admin"],
  swap_calls: ["swap_calls"],
  textsms: ["textsms"],
  chat: ["chat"],
  person_add_disabled: ["person_add_disabled"],
  import_contacts: ["import_contacts"],
  comment: ["comment"],
  rss_feed: ["rss_feed"],
  text_inbound: ["text_inbound"],
  text_outbound: ["text_outbound"],
  quick_reply: ["quick_reply"],
  attach_email: ["attach_email"],
  mark_chat_read: ["mark_chat_read"],
  mark_chat_unread: ["mark_chat_unread"],
  mark_email_read: ["mark_email_read"],
  mark_email_unread: ["mark_email_unread"],
  email: ["email", "mail"],
  phonelink_lock: ["phonelink_lock"],
  textsms_off: ["textsms_off"],
  email_off: ["email_off"],
  forum_off: ["forum_off"],
  hub: ["hub"],
  email_outbound: ["email_outbound"],
  email_inbound: ["email_inbound"],
  digital_in: ["digital_in"],
  digital_out: ["digital_out"],
  add2: ["add", "plus"],
  add_circle_outline: ["add_circle_outline", "plus_circle"],
  archive: ["archive"],
  backspace: ["backspace"],
  block: ["block"],
  clear: ["clear"],
  create: ["create", "edit"],
  cut: ["cut"],
  drafts: ["drafts"],
  file_copy: ["file_copy"],
  filter_list: ["filter_list"],
  flag: ["flag"],
  font_download: ["font", "font_download"],
  forward: ["forward"],
  how_to_reg: ["how_to_reg"],
  inbox: ["inbox"],
  link: ["link"],
  link_off: ["link_off"],
  low_priority: ["low_priority"],
  move_to_inbox: ["move_to_inbox"],
  paste: ["paste"],
  redo: ["redo"],
  remove: ["remove", "minus"],
  remove_circle_outline: ["remove_circle_outline", "minus_circle"],
  reply: ["reply"],
  reply_all: ["reply_all"],
  report: ["report"],
  report_gmailerrorred: ["report_outline"],
  report_off: ["report_off"],
  save: ["save"],
  save_alt: ["save_alt"],
  send: ["send"],
  sort: ["sort"],
  unarchive: ["unarchive"],
  undo: ["undo", "reset"],
  remove_circle: ["remove_circle"],
  outlined_flag: ["flag_outline", "outlined_flag"],
  "saved-search": ["saved_search"],
  medication: ["medication"],
  access_alarm: ["access_alarm"],
  time: ["access_time", "schedule", "time", "clock"],
  bluetooth: ["bluetooth"],
  brightness_low: ["brightness_low"],
  brightness_medium: ["brightness_medium"],
  data_usage: ["data_usage"],
  devices: ["devices"],
  eq: ["eq"],
  gps_fixed: ["gps_fixed"],
  gps_not_fixed: ["gps_not_fixed"],
  gps_off: ["gps_off"],
  signal_cellular_4_bar: ["signal_cellular_4_bar", "call_excellent"],
  signal_cellular_alt: ["signal_cellular_alt"],
  signal_cellular_connected_no_internet_4_bar: ["signal_cellular_no_internet_4_bar"],
  signal_cellular_null: ["signal_cellular_null"],
  signal_cellular_off: ["signal_cellular_off"],
  signal_wifi_4_bar_lock_48px: ["signal_wifi_4_bar_lock"],
  signal_wifi_off: ["signal_wifi_off"],
  signal_wifi_statusbar_connected_no_internet_26x24px: ["signal_wifi_no_internet"],
  signal_wifi_statusbar_not_connected_26x24px: ["signal_wifi_not_connected"],
  signal_wifi_statusbar_null_26x24px: ["signal_wifi_null"],
  storage: ["storage"],
  wifi_lock: ["wifi_lock"],
  signal_wifi_4_bar: ["signal_wifi_4_bar"],
  brightness_high: ["brightness_high"],
  security_key: ["security_key", "yubikey"],
  wifi_tethering: ["wifi_tethering"],
  reviews: ["reviews"],
  browse: ["browse"],
  stop_browse: ["stop_browse"],
  enroll_voice: ["enroll_voice"],
  insert_drive_file_outline: ["insert_drive_file_outline"],
  attach_file: ["attach_file"],
  bar_chart: ["bar_chart"],
  format_list_bulleted: ["format_list_bulleted"],
  insert_chart: ["chart", "insert_chart"],
  insert_chart_outlined: ["chart_outline", "insert_chart_outlined", "reporting"],
  insert_drive_file: ["file", "insert_drive_file"],
  merge_type: ["merge_type"],
  notes: ["notes"],
  pie_chart: ["pie_chart"],
  publish: ["publish"],
  short_text: ["short_text"],
  show_chart: ["show_chart"],
  add_comment: ["add_comment", "create_note"],
  gauge: ["gauge"],
  metric: ["metric", "numeric"],
  format_line_spacing: ["format_line_spacing"],
  multiline_chart: ["multiline_chart"],
  functions: ["functions"],
  "table-large": ["table"],
  format_size: ["format_size"],
  format_quote: ["format_quote"],
  format_bold: ["format_bold"],
  format_italic: ["format_italic"],
  strikethrough_s: ["strikethrough_s"],
  format_underlined: ["format_underlined"],
  format_indent_decrease: ["format_indent_decrease"],
  format_indent_increase: ["format_indent_increase"],
  format_color_text: ["format_color_text"],
  format_clear: ["format_clear"],
  format_align_center: ["format_align_center"],
  format_align_justify: ["format_align_justify"],
  format_align_left: ["format_align_left"],
  format_align_right: ["format_align_right"],
  "format-subscript": ["format_subscript"],
  "format-superscript": ["format_superscript"],
  "format-header-1": ["format_header_1"],
  "format-header-2": ["format_header_2"],
  "format-header-3": ["format_header_3"],
  "format-header-4": ["format_header_4"],
  "format-header-5": ["format_header_5"],
  "format-header-6": ["format_header_6"],
  format_list_numbered: ["format_list_numbered"],
  "format-paragraph": ["format_paragraph"],
  attachment: ["attachment"],
  cloud: ["cloud"],
  cloud_done: ["cloud_done"],
  cloud_download: ["cloud_download"],
  cloud_off: ["cloud_off"],
  cloud_queue: ["cloud_queue"],
  cloud_upload: ["cloud_upload"],
  create_new_folder: ["create_new_folder"],
  download: ["download"],
  download_done: ["download_done"],
  folder: ["folder"],
  folder_open: ["folder_open"],
  folder_shared: ["folder_shared"],
  upload: ["upload"],
  code_braces_box: ["code_braces_box"],
  code_box: ["code_box"],
  file_code: ["file_code"],
  file_document: ["file_document"],
  file_gif_box: ["file_gif_box"],
  file_image: ["file_image"],
  file_jpg_box: ["file_jpg_box"],
  file_music: ["file_audio", "file_music"],
  file_png_box: ["file_png_box"],
  file_presentation_box: ["file_presentation"],
  file_table_box: ["file_table_box"],
  file_table: ["file_table"],
  file_video: ["file_video", "file_movie"],
  music_box: ["music_box"],
  text_box: ["text_box"],
  zip_box: ["zip_box"],
  file_braces: ["file_braces"],
  device_hub: ["device_hub"],
  headset: ["headset"],
  headset_mic: ["headset_mic"],
  keyboard_hide: ["keyboard_hide"],
  keyboard_return: ["keyboard_return"],
  keyboard_tab: ["keyboard_tab"],
  phonelink: ["phonelink"],
  security: ["security"],
  keyboard: ["keyboard"],
  keyboard_backspace: ["keyboard_backspace"],
  robot: ["robot"],
  keyboard_capslock: ["keyboard_capslock"],
  keyboard_double_arrow_down: ["keyboard_double_arrow_down"],
  keyboard_double_arrow_up: ["keyboard_double_arrow_up"],
  add_to_photos: ["add_to_photos"],
  brush: ["brush"],
  camera_alt: ["camera_alt"],
  collections: ["collections"],
  crop: ["crop"],
  crop_free: ["crop_free"],
  crop_original: ["crop_original"],
  filter: ["filter"],
  panorama: ["panorama"],
  color_lens: ["color_lens"],
  tune: ["tune"],
  view_comfy: ["view_comfy"],
  view_compact: ["view_compact"],
  picture_as_pdf: ["picture_as_pdf"],
  portrait: ["portrait"],
  timer: ["timer"],
  timer_off: ["timer_off"],
  collections_bookmark: ["collections_bookmark"],
  image: ["image"],
  wb_sunny: ["wb_sunny"],
  assistant: ["assistant"],
  adjust: ["adjust"],
  blur_on: ["blur_on"],
  filter_center_focus: ["filter_center_focus", "actual_size"],
  flash_on: ["flash_on"],
  grid_on: ["grid_on"],
  colorize: ["colorize"],
  palette: ["palette"],
  auto_awesome_motion: ["auto_awesome_motion"],
  medical_services: ["medical_services"],
  px: ["360"],
  layers: ["layers"],
  local_offer: ["offer", "local_offer"],
  place: ["place", "location", "location_on"],
  zoom_out_map: ["zoom_out_map"],
  layers_clear: ["layers_clear"],
  local_parking: ["parking", "local_parking"],
  miscellaneous_services: ["miscellaneous_services"],
  directions_car: ["car", "directions_car"],
  arrow_back: ["arrow_back"],
  arrow_back_ios: ["arrow_back_ios"],
  arrow_downward: ["arrow_downward"],
  arrow_drop_down: ["arrow_drop_down"],
  arrow_drop_up: ["arrow_drop_up"],
  arrow_forward: ["arrow_forward"],
  arrow_forward_ios: ["arrow_forward_ios"],
  arrow_left: ["arrow_left"],
  arrow_right: ["arrow_right"],
  arrow_upward: ["arrow_upward"],
  cancel: ["cancel", "close_circle"],
  check: ["check"],
  chevron_left: ["chevron_left"],
  chevron_right: ["chevron_right"],
  close: ["close"],
  expand_less: ["expand_less", "chevron_up"],
  expand_more: ["expand_more", "chevron_down"],
  first_page: ["first_page"],
  fullscreen: ["fullscreen"],
  fullscreen_exit: ["fullscreen_exit"],
  last_page: ["last_page"],
  more_horiz: ["more_horiz", "dots"],
  more_vert: ["more_vert"],
  refresh: ["refresh"],
  subdirectory_arrow_left: ["subdirectory_arrow_left"],
  subdirectory_arrow_right: ["subdirectory_arrow_right"],
  unfold_less: ["unfold_less"],
  unfold_more: ["unfold_more"],
  bullet: ["bullet"],
  arrow_drop_up_down: ["arrow_drop_up_down"],
  menu: ["menu", "callbar_menu"],
  apps: ["apps"],
  menu_open: ["menu_open"],
  panel_open: ["panel_open"],
  do_not_disturb: ["do_not_disturb"],
  do_not_disturb_off: ["do_not_disturb_off"],
  do_not_disturb_on: ["do_not_disturb_on"],
  enhanced_encryption: ["enhanced_encryption"],
  event_available: ["event_available"],
  event_busy: ["event_busy"],
  event_note: ["event_note", "daterange"],
  more: ["more"],
  no_encryption: ["no_encryption"],
  sync: ["sync"],
  sync_disabled: ["sync_disabled"],
  sync_problem: ["sync_problem"],
  vpn_lock: ["vpn_lock"],
  wifi: ["wifi"],
  wifi_off: ["wifi_off"],
  network1: ["network1", "network_disabled"],
  network2: ["network2"],
  network3: ["network3"],
  network4: ["network4"],
  network5: ["network5"],
  ac_unit: ["snowflake", "ac_unit"],
  free_breakfast: ["breakfast", "free_breakfast"],
  wrap_up: ["wrap_up"],
  away: ["away"],
  offline: ["offline"],
  available: ["available"],
  on_call: ["busy"],
  group: ["group", "user_group"],
  group_add: ["group_add"],
  mood: ["mood"],
  mood_bad: ["mood_bad", "mood_upset"],
  notifications: ["notifications", "notification"],
  notifications_active: ["notifications_active"],
  notifications_none: ["notifications_none"],
  notifications_off: ["notifications_off"],
  notifications_paused: ["notifications_paused"],
  person: ["person", "user"],
  person_add: ["person_add"],
  person_disabled: ["person_disabled", "user_disabled"],
  public: ["world", "public"],
  sentiment_dissatisfied: ["sentiment_dissatisfied", "mood_agitated"],
  sentiment_neutral: ["sentiment_neutral"],
  sentiment_ok: ["sentiment_ok", "mood_content"],
  sentiment_satisfied: ["sentiment_satisfied", "mood_pleased"],
  sentiment_very_dissatisfied: ["sentiment_very_dissatisfied"],
  sentiment_very_satisfied: ["sentiment_very_satisfied", "mood_ecstatic"],
  share: ["share"],
  person_remove: ["person_remove"],
  person_search: ["person_search"],
  star: ["star", "favorite_full"],
  star_border: ["star_outline", "star_border"],
  star_half: ["star_half"],
  check_box: ["check_box"],
  check_box_outline_blank: ["check_box_unchecked", "check_box_outline_blank"],
  radio_button_checked: ["radio_button_checked"],
  radio_button_unchecked: ["radio_button_unchecked"],
  indeterminate_check_box: ["indeterminate_check_box"],
  app_cfm: ["app_cfm"],
  app_live: ["app_live"],
  app_wfm: ["app_wfm"],
  app_account: ["app_account"],
  app_activity: ["app_activity", "app_activities"],
  app_admin: ["app_admin"],
  app_agent_assist: ["app_agent_assist", "app_aa"],
  app_ai_trainer: ["app_ai_trainer"],
  app_contacts: ["app_contacts"],
  app_conversation: ["app_conversation", "app_conversations"],
  app_developers: ["app_developers"],
  app_dialpad: ["app_dialpad"],
  app_dummy: ["app_dummy"],
  app_guardian: ["app_guardian"],
  app_guide: ["app_guide"],
  app_helper: ["app_helper"],
  app_home: ["app_home"],
  app_launchpad: ["app_launchpad"],
  app_new: ["app_new"],
  app_notifications: ["app_notifications"],
  "app_outbound-dialer": ["app_outbound-dialer", "app_dialer"],
  app_performance_management: ["app_performace_management", "app_pm"],
  app_polyglot: ["app_polyglot"],
  app_quality_management: ["app_quality_management", "app_qm"],
  app_screen_recording: ["app_screen_recording"],
  app_studio: ["app_studio"],
  app_uc_admin: ["app_uc_admin"],
  app_uc_phone: ["app_uc_phone"],
  app_virtual_agent: ["app_virtual_agent", "app_va"],
  app_voicemail: ["app_voicemails"],
  app_workspace_designer: ["app_workspace_designer"],
  app_workspace_designer_dashboard: ["app_workspace_designer_dashboard"],
  app_workspace_designer_cards: ["app_workspace_designer_cards"],
  app_visual_support: ["app_visual_support"],
  app_interaction_analytics: ["app_interaction_analytics"],
  app_social_media: ["app_social_media"],
  app_identity: ["app_identity"],
  app_social_engagement: ["app_social_engagement"],
  app_digital_channel_engagement: ["app_digital_channel_engagement"],
  app_explore: ["app_explore"],
  app_speech_analytics: ["app_speech_analytics"],
  app_builder: ["app_builder"],
  app_workspace_designer_panel: ["workspace_designer_panel", "app_workspace_designer_panel"],
  feature_manual_evaluation: ["feature_manual_evaluation"],
  feature_cx_sensors: ["feature_cx_sensors"],
  feature_add_internal_note: ["feature_add_internal_note"],
  feature_add_subcase: ["feature_add_subcase"]
};

export default Icon;
export { iconsCatalog };
